import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import {
  Box,
  Button,
  Card,
  Chip,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import SrtDashboardCard from "./Srtdashboardcard";
import { getRescheduledcounts } from "../../redux/features/srtSlice";
import Loader3D from "../../components/Loader/Loader3D";
import Iconify from "../../components/Iconify";

const SRTdashboard = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;
  const userID = userProfile.userId;

  const [fromDate, setFromDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { srtCountData, loading } = useSelector((state) => state.srt);

  useEffect(() => {
    dispatch(
      getRescheduledcounts({
        fromDate: fromDate,
        toDate: toDate,
        userId: userID,
      })
    );
  }, [fromDate, toDate]);

  const topCounts = srtCountData.headerData;

  const handlenavigate = useCallback(
    (projectId) => {
      navigate(
        `/my-workspace/srt-croview?fromDate=${fromDate}&toDate=${toDate}&projectId=${projectId}`
      );
    },
    [fromDate, toDate, navigate]
  );

  const handlenavigateTA = useCallback(
    (projectId) => {
      navigate(
        `/my-workspace/srt-taview?fromDate=${fromDate}&toDate=${toDate}&projectId=${projectId}`
      );
    },
    [fromDate, toDate, navigate]
  );

  return (
    <GlobalWrapper title={"Session Reschedule Tracker"}>
      <Box sx={{ display: "flex", mb: 1 }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          alignItems: "center",
          gap: 2,
        }}
      >
        <Card
          sx={{
            backgroundImage: "linear-gradient(to right, #386150,#58B09C)",
            color: "#fff",
            borderRadius: "15px",
            width: "100%",
            maxWidth: 350,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            Total Rescheduled : {topCounts?.total_rescheduled_session}
          </Typography>
        </Card>
      </Box>
      <Box
        sx={{
          paddingTop: 2,
        }}
      >
        {loading ? (
          <Loader3D />
        ) : (
          <Grid container spacing={2}>
            {srtCountData.projectData?.map((data) => (
              <Grid item xs={12} sm={6} md={3} key={data.project_id}>
                <SrtDashboardCard
                  name={data.project_name}
                  projectName={data.project_name}
                  rescheduledCount={data.total_rescheduled_count}
                  color="#7054eb"
                  navigatebuttons={
                    <>
                      <Box
                        sx={{
                          gap: "10px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Button
                          sx={{
                            color: "#fff",
                            borderRadius: "20px",
                            backgroundColor: "none",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            border: "1px solid white",
                            "&:hover": {
                              backgroundColor: "white",
                              color: "#386150",
                              border: "1px solid white",
                            },
                          }}
                          size="small"
                          variant="text"
                          onClick={() => handlenavigate(data.project_id)}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              px: "2px",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="button"
                              sx={{ color: "inherit" }}
                            >
                              CRM View
                            </Typography>
                            <Iconify
                              icon={"mdi:eye"}
                              color="inherit"
                              width={35}
                              height={35}
                            />
                            <Typography sx={{ fontWeight: 600 }}>
                              {data.rescheduled_count_parent}
                            </Typography>
                          </Box>
                        </Button>

                        <Button
                          sx={{
                            color: "#386150",
                            borderRadius: "20px",
                            backgroundColor: "white",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            border: "1px solid white",
                            "&:hover": {
                              backgroundColor: "none",
                              color: "#fff",
                              border: "1px solid white",
                            },
                          }}
                          size="small"
                          variant="text"
                          onClick={() => handlenavigateTA(data.project_id)}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              px: "2px",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="button"
                              sx={{ color: "inherit" }}
                            >
                              TA View
                            </Typography>
                            <Iconify
                              icon={"mdi:eye"}
                              color="inherit"
                              width={35}
                              height={35}
                            />
                            <Typography sx={{ fontWeight: 600 }}>
                              {data.rescheduled_count_tutor}
                            </Typography>
                          </Box>
                        </Button>
                      </Box>
                    </>
                  }
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default SRTdashboard;
